import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import styles from './BuyersInformation.module.scss';

const BuyersInformation = ({ paymentRequestToken }) => {
    const { t } = useTranslation();
    return (
        <div className={styles.information}>
            <div className={styles.information_header}>{t('informations')}</div>
            <div className={styles.information_content}>
                <div className={styles.buyers}>
                    <div className={styles.buyers_header}>{t('buyerInformation')}</div>
                    <div className={styles.buyers_value}>{paymentRequestToken?.last_name} {paymentRequestToken?.first_name}</div>
                    <div className={styles.buyers_value}>{paymentRequestToken?.email}</div>
                    <div className={styles.buyers_value}>{paymentRequestToken?.phone_number}</div>
                </div>
            </div>
        </div>
    );
};

BuyersInformation.propTypes = {
    paymentRequestToken: PropTypes.object,
};

export default BuyersInformation;
